import urls from './urls';
import axios, { AxiosResponse } from 'axios';
import './useRest'; // this is required to create restServiceInstance
import { videoUpload } from '../functions/videoUploadHelper';

interface LoginRHPParams {
    user: any;
    buildVersion?: string;
    agent?: any;
    identifier?: string;
    reCAPTCHAToken?: string;
}

interface LoginRHPWebParams {
    [key: string]: any;
}

interface LoginParams {
    xmppId: string;
    password?: string;
}

class authApi {
    static loginRHP(user: any, buildVersion?: string, agent?: any, identifier?: string, reCAPTCHAToken?: string) {
        // this.restClient = new RestClient();
        // this.restClient.setBaseUrl(urls.AUT_RHPURL);
        let url: string = urls.RHP_LOGIN;
        if (buildVersion && agent) {
            url = `${url}?version=${buildVersion}&agent=${JSON.stringify(agent)}`;
        }
        if (identifier) {
            url = `${url}&identifier=${identifier}`;
        }
        if (reCAPTCHAToken) {
            url = `${url}&vetoken=${reCAPTCHAToken}`;
        }
        return axios.post(encodeURI(url), user, { baseURL: urls.AUT_RHPURL, headers: { isAnonymous: true } }).then(res => res);
    }
    static logoutRHP() {
        // this.restClient = new RestClient();
        // this.restClient.setBaseUrl(urls.AUT_RHPURL);
        // return this.restClient.execute(urls.RHP_LOGOUT, ApiMethod.POST, null, false).then(res => res);
        return axios.post(encodeURI(urls.RHP_LOGOUT), null, { baseURL: urls.AUT_RHPURL, headers: { isAnonymous: false } }).then(res => res);
    }

    static loginRHPWeb(params: LoginRHPWebParams) {
        // this.restClient = new RestClient();
        // this.restClient.setBaseUrl(urls.DEV_RHPURL);
        // return this.restClient.execute(urls.RHP_LOGIN_WEB, ApiMethod.POST, params, true).then(res => {
        //   return res;
        // });
        return axios.post(encodeURI(urls.RHP_LOGIN_WEB), params, { baseURL: urls.DEV_RHPURL, headers: { isAnonymous: true } }).then(res => res);
    }

    static login(xmppId: string, password?: string) {
        // this.restClient = new RestClient();
        // this.restClient.setBaseUrl(urls.BASE_URL);
        // const url = urls.USER_LOGIN;
        // return this.restClient.execute(url, ApiMethod.POST, { xmppId, password }, true).then(response => {
        //   return response;
        // });
        return axios
            .post(encodeURI(urls.USER_LOGIN), { xmppId, password }, { baseURL: urls.BASE_URL, headers: { isAnonymous: true } })
            .then(res => res);
    }
    static getAnonymousAccessToken() {
        // this.restClient = new RestClient();
        // this.restClient.setBaseUrl(urls.BASE_RHPURL);
        // const url = urls.GET_ANONYMOUS_ACCESS_TOKEN;
        // return this.restClient.execute(url, ApiMethod.GET, null, true).then(response => {
        //   return response;
        // });
        return axios
            .get(encodeURI(urls.GET_ANONYMOUS_ACCESS_TOKEN), { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } })
            .then(res => res);
    }

    static updateRetainStatus(params: { enableRecurring: boolean; [key: string]: any }) {
        // this.restClient = new RestClient();
        // this.restClient.setBaseUrl(urls.BASE_RHPURL);
        let url: string = urls.ENABLE_RECERRING;
        if (params.enableRecurring) {
            url = urls.DISABLE_RECERRING;
        }

        // return this.restClient.execute(url, ApiMethod.POST).then(response => {
        //   return response;
        // });
        return axios.post(url, null, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } }).then(res => res);
    }
    // static refreshTokenRHP(refreshToken){
    //   this.restClient = new RestClient();
    //   this.restClient.setBaseUrl(urls.AUT_RHPURL);
    //   let url = urls.urls.RHP_GET_ACCESSTOKEN;
    //   let body ={
    //     RefreshToken:refreshToken
    //   }
    //
    //   return this.restClient.execute(url, ApiMethod.POST, body, true).then((response) => {
    //     return response;
    //   });
    // }

    static getCreditCard() {
        // this.restClient = new RestClient();
        // this.restClient.setBaseUrl(urls.BASE_RHPURL);
        // return this.restClient.execute(urls.GET_CREDIT_CARD, ApiMethod.GET);
        return axios.get(encodeURI(urls.GET_CREDIT_CARD), { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } }).then(res => res);
    }

    static deleteCreditCard() {
        // this.restClient = new RestClient();
        // this.restClient.setBaseUrl(urls.BASE_RHPURL);
        // return this.restClient.execute(urls.DELETE_CREDIT_CARD, ApiMethod.DELETE);
        return axios
            .delete(encodeURI(urls.DELETE_CREDIT_CARD), { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } })
            .then(res => res);
    }

    static updateCreditCard(params: any) {
        // this.restClient = new RestClient();
        // this.restClient.setBaseUrl(urls.BASE_RHPURL);
        //
        // return this.restClient.execute(urls.UPGRADE_PURCHASE, ApiMethod.POST, params);
        return axios
            .post(encodeURI(urls.UPGRADE_PURCHASE), params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } })
            .then(res => res);
    }

    static accountLookup(params: any) {
        return axios
            .post(urls.RHP_ACCOUNT_LOOK_UP, params, {
                baseURL: urls.AUT_RHPURL,
                headers: { isAnonymous: true },
            })
            .then(res => res);
    }

    static createUserVerificationVideo(data: any) {
        try {
            const url = urls.MERGE_USER_VERIFICATION_ASYNC;
            const params = {
                ...data,
                mergeURL: url,
                id: data.id,
                compress: data.compress,
                mergedMetaData: {
                    ParentID: data.parentID,
                    ParentType: data.parentType,
                    SortNumber: data.sortNumber,
                },
                file: data.file,
            };
            // @ts-ignore
            return videoUpload(params);
        } catch (error) {
            console.log('Error creating user verification video:', error);
            throw error;
        }
    }
}

export default authApi;
